const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Quizzes Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Saml', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/v3/saml/:subresource', null, {
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    update: {params: {subresource: 'update'}, method: 'POST', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false}
  });
  
}]);
